<template>
  <p>runTest.vue</p>
</template>

<script>
export default {
  name: "runTest",
};
</script>

<style scoped></style>
